import { Box } from '@mui/material';
import PackageContents from './PackageContents';
import Headline4 from 'components/elements/Headline4';
import { translate } from 'utils/Translate';
import OrderTrackingStatus from './OrderTrackingStatus';

function OrderTrackingOrderPart(props) {
  const { order, index } = props;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, flex: 1 }}>
      <Headline4>
        {translate('_PROFILE_ORDER_PART_', 'Ordredel')} {index}
      </Headline4>

      <OrderTrackingStatus
        orderFlowStatus={order.orderFlowStatus}
        trackingEvents={order.trackingEvents}
        trackingUrl={order.trackingUrl}
        trackingNumber={order.trackingNumber}
      />

      <PackageContents
        orderlines={order.orderLines}
      />
    </Box>
  );
}

export default OrderTrackingOrderPart;